<template>
  <rest-form-page
    :page-title="pageTitle"
    :fetch-endpoint="fetchEndpoint"
    :save-endpoint="saveEndpoint"
    :model="model"
    :readonly="readonly"
  >
    <template slot="form" v-if="model">
      <form-section>
        <el-row>
          <el-col :span="12">
            <rest-form-item
              prop="pulsar_events_enabled"
              :hint="$t('StreamingSettings_Field_PulsarEventsEnabled_Hint')"
            >
              <toggle
                v-model="model.pulsar_events_enabled"
                :text="$t('StreamingSettings_Field_PulsarEventsEnabled')"
              />
            </rest-form-item>

            <rest-form-item
              prop="pulsar_messages_enabled"
              :hint="$t('StreamingSettings_Field_PulsarMessagesEnabled_Hint')"
            >
              <toggle
                v-model="model.pulsar_messages_enabled"
                :text="$t('StreamingSettings_Field_PulsarMessagesEnabled')"
              />
            </rest-form-item>

            <rest-form-item
              prop="pulsar_distribute_clickhouse_processed"
              :hint="
                $t(
                  'StreamingSettings_Field_PulsarDistributeClickhouseProcessed_Hint'
                )
              "
            >
              <toggle
                v-model="model.pulsar_distribute_clickhouse_processed"
                :text="
                  $t(
                    'StreamingSettings_Field_PulsarDistributeClickhouseProcessed'
                  )
                "
              />
            </rest-form-item>

            <rest-form-item
              prop="pulsar_events_schema"
              :label="$t('StreamingSettings_Field_PulsarEventsSchema')"
              :hint="$t('StreamingSettings_Field_PulsarEventsSchema_Hint')"
            >
              <el-select v-model="model.pulsar_events_schema">
                <el-option
                  :value="0"
                  :label="$t('StreamingSettings_PulsarEventsSchema_LegacyOnly')"
                />
                <el-option
                  :value="1"
                  :label="
                    $t('StreamingSettings_PulsarEventsSchema_StandardizedOnly')
                  "
                />
                <el-option
                  :value="2"
                  :label="$t('StreamingSettings_PulsarEventsSchema_Both')"
                />
              </el-select>
              <el-alert
                v-if="model.pulsar_events_schema === 1"
                :title="
                  $t(
                    'StreamingSettings_PulsarEventsSchema_StandardizedOnly_Warning'
                  )
                "
                type="error"
                :closable="false"
                show-icon
                style="margin-top: 8px"
              />
            </rest-form-item>
          </el-col>
        </el-row>
      </form-section>
    </template>
  </rest-form-page>
</template>

<script>
import RestFormPage from '@/common/components/rest/RestFormPage'
import RestFormItem from '@/common/components/rest/RestFormItem'
import FormSection from '@/common/components/form/FormSection'
import Toggle from '@/common/components/form/Toggle'
import { projectEndpoint } from '@/core/helpers'

export default {
  name: 'StreamingSettingsPage',

  components: {
    Toggle,
    RestFormPage,
    RestFormItem,
    FormSection
  },

  data() {
    return {
      model: null
    }
  },

  computed: {
    pageTitle() {
      return (
        this.$store.getters.embeddedTitle || this.$t(this.$route.meta.title)
      )
    },

    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: ``,
        params: {
          fields:
            'pulsar_events_enabled,pulsar_messages_enabled,pulsar_distribute_clickhouse_processed,pulsar_events_schema'
        },
        handler: data => {
          this.model = data
        }
      })
    },

    saveEndpoint() {
      return projectEndpoint({
        method: 'patch',
        url: ``,
        params: {
          data: this.model
        }
      })
    },

    readonly() {
      return !this.$isRole('admin')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/settings/pages/StreamingSettingsPage.vue